import { useFormikContext } from 'formik';
import SinhHieu from '../../../../../../../../../../phan-he-kham-benh/components/tab-kham-benh/SinhHieu';
import ThongTinBenh from '../../ho-so-benh-an/components/ThongTinBenh';
import BenhKemTheo from './BenhKemTheo';
import CapNhatTuPhieuChucNangSongButton from './CapNhatTuPhieuChucNangSongButton';
import ChanDoan from './ChanDoan';
import PhieuDieuTriAction from './PhieuDieuTriAction';
import TomTatKetQuaCanLamSang from './TomTatKetQuaCanLamSang';

interface Props {
	data: any;
}

const CustomComponent = ({ data }: Props) => {
	const { values, setValues, setFieldValue } = useFormikContext<any>();

	const Default = () => {
		return <></>;
	};

	const components: { [key: string]: any } = {
		thongTinSinhHieu: () => <SinhHieu sinhHieu={{}} className="spaces pt-10" />,
		chanDoan: ChanDoan,
		benhKemTheo: BenhKemTheo,
		phieuDieuTriAction: PhieuDieuTriAction,
		capNhatTuPhieuChucNangSongButton: CapNhatTuPhieuChucNangSongButton,
		tomTatKetQuaCanLamSang: TomTatKetQuaCanLamSang,
		thongTinBenh: () => <ThongTinBenh showPhanBiet={false} />
	};

	const DynamicContent = components[data?.componentName] || Default;

	if (data?.componentName === "thongTinSinhHieu") {
		return <SinhHieu
			sinhHieu={values?.phieuDieuTri || {}}
			setSinhHieu={(name: string, value: any) => setFieldValue("phieuDieuTri", {
				...values?.phieuDieuTri,
				[name]: value
			})}
			className="spaces pt-10" 
			disabled={data?.isView}
		/>
	}

	const props: Record<string, any> = {
		chanDoan: {
			containerClassName: 'pl-15',
			endRowClassName: 'spaces pr-0',
		},
		tomTatKetQuaCanLamSang: {
			isDialog: values?.isDialog
		}
	};

	return <DynamicContent {...data} {...props[data?.componentName]} />;
};

export default CustomComponent;
